import apiClient from '../apiClient';
import { GET_RESTAURANT_CLASS_URL } from '../apiUrl';

const getRestaurantClassApi = () => {
  return apiClient.get(GET_RESTAURANT_CLASS_URL);
};

export default getRestaurantClassApi;
